import { ICompetitorAnalysisArray, IPrePanelInformation, IProductAnalysis, ISKUPerformanceMetrics } from "@/types/PrePanelInformation.types";

// export const DefaultPrepanelInformationFormData: IPrePanelInformation = {
//   vendorId: "",
//   skuPerformanceMetrics: [{
//     existingProductSku: "",
//     existingProductName: "",
//     retailPriceOfExistingProduct: null,
//     sizeOzOfExistingProduct: null,
//     weeklySalesOfExistingProduct: null,
//     weeklySoldEachOfExistingProduct: null,
//     salesPerStorePerWeekOfExistingProduct: null,
//     avgUnitsSoldPerStoreOfExistingProduct: null,
//     percentChangeTyLyOfExistingProduct: null,
//     pricePerOunceOfExistingProduct: null,
//   }],
//   competitorAnalysis: [
//     {
//       competitorBrandRetailer: "",
//       retailPriceOfCompetitorProduct: null,
//       sizeOzOfCompetitorProduct: null,
//       pricePerOunceOfCompetitorProduct: null,
//     }
//   ],
//   productAnalysis: {
//     ideaId: '',
//     vendorAssessmentId: '',
//     businessStatus: '',
//     ingredientId: '',
//     title: '',
//     categoryManagerUser: { id: '', userName: '', userId: '' },
//     developer: '',
//     businessCategory: { id: '', categoryId: '', description: '', categoryType: '', leader: '' },
//     productType: '',
//     sellingPeriod: '',
//     reasonForDevelopment: '',
//     requiredAttributes: '',
//     estWeeklySales: null,
//     estWeeklyUnitVol: null,
//     description: '',
//     vendorCorporateName: '',
//     retailPrice: null,
//     size: '',
//     packSize: null,
//     panelDate: '',
//     typeOfPackage: '',
//     ingredientList: '',
//     unacceptableIngredients: '',
//     retailStructure: '',
//     logistics: '',
//     shelfLife: '',
//     typeOfVendor: '',
//     nutritionFactPanel: null,
//     questionnaire: { PC: [], CM: [] },
//     availableTransitions: null
//   }
// }

// Explicit type for SKU Performance Metrics
export const DefaultSKUPerformanceMetrics: ISKUPerformanceMetrics = {
  existingProductSku: null,
  existingProductName: "",
  retailPriceOfExistingProduct: null,
  sizeOzOfExistingProduct: null,
  weeklySalesOfExistingProduct: null,
  weeklySoldEachOfExistingProduct: null,
  salesPerStorePerWeekOfExistingProduct: null,
  avgUnitsSoldPerStoreOfExistingProduct: null,
  percentChangeTyLyOfExistingProduct: null,
  pricePerOunceOfExistingProduct: null
};

// Explicit type for Competitor Analysis
export const DefaultCompetitorAnalysis: ICompetitorAnalysisArray = {
  competitorBrandRetailer: "",
  retailPriceOfCompetitorProduct: null,
  sizeOzOfCompetitorProduct: null,
  pricePerOunceOfCompetitorProduct: null,
};

// Explicit type for Product Analysis
export const DefaultProductAnalysis: IProductAnalysis = {
  ideaId: '',
  vendorAssessmentId: '',
  businessStatus: '',
  ingredientId: '',
  title: '',
  categoryManagerUser: {
        id: "",
        userName: "",
        userId: "",
      },
  developer: '',
  businessCategory: "",
  productType: "",
  panelType: "",
  sellingPeriod: "",
  reasonForDevelopment: '',
  requiredAttributes: [{ value: "", label: "" }],
  estWeeklySales: null,
  estWeeklyUnitVol: null,
  description: '',
  vendorCorporateName: '',
  retailPrice: null,
  size: '',
  packSize: null,
  panelDate: '',
  typeOfPackage: "",
  ingredientList: '',
  unacceptableIngredients: '',
  retailStructure: "",
  logistics: "",
  shelfLife: '',
  typeOfVendor: "",
  countryOfOrigin: "",
  tariff: '',
  nutritionFactPanel: null,
  questionnaire: { PC: [], CM: [] },
  availableTransitions: null,
  giftPack: false,
  amountOfProductsInGiftPack: null,
  productSpecification: []
};

// Default Prepanel Information Form Data
export const DefaultPrepanelInformationFormData: IPrePanelInformation = {
  vendorId: "",
  skuPerformanceMetrics: [ { ...DefaultSKUPerformanceMetrics } ],
  competitorAnalysis: [ { ...DefaultCompetitorAnalysis } ],
  productAnalysis: { ...DefaultProductAnalysis },
};
